import { Component, OnInit } from '@angular/core';
import { MasterService,AttendanceService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-roomallocation',
  templateUrl: './roomallocation.component.html',
  styleUrls: ['./roomallocation.component.scss'],
  providers:[MasterService,AttendanceService]
})
export class RoomallocationComponent implements OnInit {

  sections:any=[];
  classes:any=[];
  fmodel:any={};
  attdata:any=[];
  arrcourse:any=[];
  arrrooms:any=[];
  oprtype:any='';
  tabledata: any = {};
  strattmarked="";
  showload:any="no";
  showsms:any="no";

  arrqrtypes:any=
  [
  {name:'2UP Barode',value:'2Upevlstubar'},
  {name:'3UP Barode',value:'3Upevlstubar'},
  ];
  closeResult: string;
  modalOptions:NgbModalOptions;
  smmodalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  private smallmodalRef: NgbModalRef;
  constructor(private http: HttpClient,private aservice:AttendanceService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }

  ngOnInit(): void {
    this.mascourse();
    //this.massection();
    this.fmodel.attdt=this.mservice.getdatetoday();
  }


  // masclass() {
  //   this.mservice.masclass()
  //       .subscribe(
  //       resultArray => {
  //           console.log('getdashcounts', resultArray);
  //           this.classes = resultArray;
  //           this.fmodel.clid=resultArray[0].clid;
  //          this.massection();
  //       },
  //       error => console.log("Error :: " + error)
  //       )
  // }

  masclass() {
    this.mservice.masclass()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
            this.fmodel.clid=resultArray[0].clid;
            //this.fmodel1.clid=resultArray[0].clid;
            this.massection();
          //  this.masperiod();
           // this.mascourse();
           
        },
        error => console.log("Error :: " + error)
        )
  }

  getevlrooms() {
    this.mservice.getevlrooms()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrrooms = resultArray;
            this.fmodel.rmid=resultArray[0].rmid;
            //this.fmodel1.clid=resultArray[0].clid;
            //this.massection();
          //  this.masperiod();
           // this.mascourse();
           this.SelectAttdDetails();
           
        },
        error => console.log("Error :: " + error)
        )
  }

  mascourse() {
    this.mservice.mascourse()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrcourse = resultArray;
            this.fmodel.crid=resultArray[0].crid;
            this.masclass();
            //this.fmodel1.crid=resultArray[0].crid;
        },
        error => console.log("Error :: " + error)
        )
  }

  // massection() {
  //   this.mservice.massection()
  //       .subscribe(
  //       resultArray => {
  //           console.log('getdashcounts', resultArray);
  //           this.sections = resultArray;
  //           this.fmodel.secid=resultArray[0].scid;
  //       },
  //       error => console.log("Error :: " + error)
  //       )
  // }

  massection() {
    this.mservice.massection()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.sections = resultArray;
            this.fmodel.secid=resultArray[0].scid;
           // this.SelectAttdDetails();
           this.getevlrooms();
            // this.fmodel1.scid=resultArray[0].scid;
            // this.subjects(this.fmodel.clid,this.fmodel.crid);
        },
        error => console.log("Error :: " + error)
        )
  }

  printqrlabelsbulk(obj){
    debugger;
      var clcd=localStorage.getItem('clcd');
      var aycd=localStorage.getItem('aycd');
       var url=this.aservice.callurl+"qrcode/2Upevlstubar.php?clcd="+clcd+"&aycd="+aycd+"&clid="+obj.clid+"&scid="+obj.secid+"&crid="+obj.crid+"&rmid="+obj.rmid;
       window.open(url,'','_blank');
     }

     openqrdl(content)
{
  // this.objqrprint.bkid=bkid;
  // this.objqrprint.nobc=1;
  this.fmodel.qrdoctype='2Upevlstubar';


  this.modalRef=this.modalService.open(content,this.smmodalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}

     printqrlabels(obj){
      debugger;
        var clcd=localStorage.getItem('clcd');
        var aycd=localStorage.getItem('aycd');
         var url=this.aservice.callurl+"qrcode/"+obj.qrdoctype+".php?clcd="+clcd+"&aycd="+aycd+"&clid="+obj.clid+"&scid="+obj.secid+"&crid="+obj.crid+"&rmid="+obj.rmid;
         window.open(url,'','');
       }
  
     expbarlist(obj){
      debugger;
        var clcd=localStorage.getItem('clcd');
        var aycd=localStorage.getItem('aycd');
         var url=this.aservice.callurl+"export/expcsv_roomallot.php?clcd="+clcd+"&aycd="+aycd+"&clid="+obj.clid+"&scid="+obj.secid+"&crid="+obj.crid+"&rmid="+obj.rmid;
         window.open(url,'');
       }
    
  SelectAttdDetails() {
    debugger
    var clid = this.fmodel.clid;
    var crid = this.fmodel.crid;
    var secid = this.fmodel.secid;
    var rmid = this.fmodel.rmid;
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    
    var asgnmtdata = { clid: clid, clcd:clcd,aycd:aycd,crid:crid,rmid:rmid };
    console.log('model-by', asgnmtdata);
    this.aservice.getroomallocationdata(asgnmtdata)
        .subscribe(resultArray => {
            console.log('ret-by-atd', resultArray);
//alert(resultArray.length);
         
           resultArray.forEach(x => x.status = x.status === 'true');
           this.attdata=resultArray;
        }, error =>
            alert('error in connection')
        );
}

// Savedetails()
// {

//   console.log('savearr',this.attdata);
// }



SelectAttdDtlsifnotavail() {
    debugger
    var clid = this.fmodel.clid;
    var crid = this.fmodel.crid;
    var secid = this.fmodel.secid;
    var attdt = this.fmodel.attdt;
    let clcd=localStorage.getItem('clcd');
    let aycd=localStorage.getItem('aycd');
    
    var asgnmtdata = { clid: clid, secid: secid, attdt: attdt,oprtype:'selstuses',clcd:clcd,aycd:aycd,crid:crid};
    console.log('model-by', asgnmtdata);
    this.aservice.by_sp_clmattendance(asgnmtdata)
        .subscribe(resultArray => {
            console.log('ret-by-atd', resultArray);
            this.attdata = resultArray;

            //alert(resultArray.message);

        }, error =>
            alert('error in connection')
        );
}


updateroomstatus(e,obj)
{
//  console.log('saveobj',this.objqbank);
this.aservice.updateroomstatus(obj,e.checked)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='success')
          {
            
          this.SelectAttdDetails();
          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )

}
}
